import { location, querystring } from 'svelte-spa-router';
import { get } from 'svelte/store';

export const NoPremiumVoucherCheckRule = {
	check: () => {
		const qrVoucherCode = new URLSearchParams(get(querystring)).get('vcode');
		const voucherModal = new URLSearchParams(get(querystring)).get('v');
		const urlLink = '/settings/premium';
		return get(location) !== urlLink && !qrVoucherCode && !voucherModal;
	},
	expected: true,
};
